<template>
  <div style="background-color: #fff;">
    <!-- <van-nav-bar title="平台二维码" left-arrow @click-left="() => {
      $router.push({
        path: '/project',
      })
    }" /> -->

    <van-nav-bar title="平台二维码" left-arrow @click-left="() => {
      $router.go(-1)
    }" />


    <div v-if="formDataInfo" @scroll="handleScroll" style="width:100%;overflow: auto;position: relative;"
      :style="formDataInfo.gjlink && formDataInfo.gjlink.url ? 'height: 50%;' : 'height: 100%;'">

      <van-field label="构件编号" v-model="formDataInfo.mdsl06" readonly placeholder="请输入"></van-field>

      <van-field label="构件区域" @change="(v) => { key = 'mdsl05'; changeInfo(v) }" v-model="formDataInfo.mdsl05"
        placeholder="请输入"></van-field>

      <van-field label="构件类型" v-model="formDataInfo.mdsl08" placeholder="请点击选择" readonly
        @click="() => { cutProjectShow = true; }"></van-field>

      <van-popup v-model="cutProjectShow" position="bottom" :style="{ height: '50%' }">
        <van-picker title="选择构件类型" show-toolbar :columns="gjtypesList" @confirm="onConfirm"
          @cancel="cutProjectShow = false" />
      </van-popup>

      <van-field label="构件长度" v-model="formDataInfo.mdsl09" placeholder="请输入"
        @change="(v) => { key = 'mdsl09'; changeInfo(v) }"></van-field>
      <van-field label="重量" v-model="formDataInfo.mdsl10" placeholder="请输入"
        @change="(v) => { key = 'mdsl10'; changeInfo(v) }"></van-field>

      <van-field label="组立完成" v-model="formDataInfo.mdsl11" :disabled="disabledFields.mdsl11" readonly
        @click="handleClick('mdsl11')" placeholder="请点击选择"></van-field>

      <van-field label="焊接完成" v-model="formDataInfo.mdsl12" :disabled="disabledFields.mdsl12" readonly
        @click="handleClick('mdsl12')" placeholder="请点击选择"></van-field>
      <van-field label="装配完成" v-model="formDataInfo.mdsl13" :disabled="disabledFields.mdsl13" readonly
        @click="handleClick('mdsl13')" placeholder="请点击选择"></van-field>
      <van-field label="制造完成" v-model="formDataInfo.mdsl14" :disabled="disabledFields.mdsl14" readonly
        @click="handleClick('mdsl14')" placeholder="请点击选择"></van-field>
      <van-field label="油漆完成" v-model="formDataInfo.mdsl15" :disabled="disabledFields.mdsl15" readonly
        @click="handleClick('mdsl15')" placeholder="请点击选择"></van-field>
      <van-field label="产品入库" v-model="formDataInfo.mdsl16" :disabled="disabledFields.mdsl16" readonly
        @click="handleClick('mdsl16')" placeholder="请点击选择"></van-field>
      <van-field label="发运" v-model="formDataInfo.mdsl17" :disabled="disabledFields.mdsl17" readonly
        @click="handleClick('mdsl17')" placeholder="请点击选择"></van-field>
      <van-field label="现场验收" v-model="formDataInfo.mdsl18" :disabled="disabledFields.mdsl18" readonly
        @click="handleClick('mdsl18')" placeholder="请点击选择"></van-field>
      <van-field label="安装完成" v-model="formDataInfo.mdsl19" :disabled="disabledFields.mdsl19" readonly
        @click="handleClick('mdsl19')" placeholder="请点击选择"></van-field>
      <van-field label="件号" v-model="formDataInfo.mdsl07" @change="(v) => { key = 'mdsl07'; changeInfo(v) }"
        placeholder="请输入，纯数字"></van-field>

      <div v-if="!isBottom && (formDataInfo.gjlink && formDataInfo.gjlink.url)" class="bottom-hint">
        <span>继续滑动查看全部内容</span>
      </div>

    </div>

    <van-popup v-model="dateProjectShow" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker type="date" @confirm="dateConfirm" @cancel="dateProjectShow = false" />
    </van-popup>

    <van-divider dashed :margin="0" v-if="formDataInfo.gjlink && formDataInfo.gjlink.url">分割线</van-divider>
    <iframe v-if="formDataInfo.gjlink && formDataInfo.gjlink.url && isHttpsUrl(formDataInfo.gjlink.url)"
      :src="formDataInfo.gjlink.url" style="height: 50%; width: 100%; border: none;" frameborder="0"></iframe>

    <div v-if="formDataInfo.gjlink && formDataInfo.gjlink.url && !isHttpsUrl(formDataInfo.gjlink.url)" style="padding: 30px;">

      <div style="font-size: 26rpx; color: #999; margin-top: 15rpx; text-align: center;">
        检测到当前为HTTP链接，小程序无法直接内嵌预览
        <br />
        {{ formDataInfo.gjlink.url }}
        <van-button type="primary" block @click="copyAndOpenUrl(formDataInfo.gjlink.url)">
          复制链接
        </van-button>
      </div>
    </div>

  </div>
</template>

<script>
import { GetComponenttraceDataById, AddOrUpdateComponenttraceData, InsertgjxgRecord } from "@/api";
export default {
  name: 'UpdateGJInfo',
  data() {
    return {
      formDataInfo: {},
      disabledFields: {},
      gjtypesList: [
        "钢梁",
        "预制飘窗",
        "一体板",
        "预制楼梯",
        "钢柱",
        "装配式装修",
        "ALC板",
        "保温装饰",
      ],
      cutProjectShow: false,
      dateProjectShow: false,
      key: '',
      key1: '',
      lastForm: null,
      isBottom: false,
      scrollThreshold: 10, // 距离底部阈值（像素）
    }
  },
  watch: {
    formDataInfo: {
      handler() {
        this.updateDisabledFields();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getComponenttraceDataByIdFC()
  },
  methods: {
    // 判断是否是https链接
    isHttpsUrl(url) {
      if (!url) return false
      const realUrl = url.trim()
      return realUrl.startsWith('https://')
    },
    // 复制链接并提示跳转浏览器
    async copyAndOpenUrl(url) {
      // 1. 优先使用 Clipboard API（现代浏览器）
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(url);
          this.$Notify({ type: "success", message: "复制成功", duration: 5000 });
          return true;
        } catch (err) {
          console.warn('Clipboard API 失败，尝试降级', err);
          // 继续执行降级方案
        }
      }

      // 2. 降级方案：execCommand
      try {
        return this.execCopy(url);
      } catch (err) {
        this.$Notify({ type: "danger", message: "复制失败", duration: 5000 });
        return false;
      }
    },
    /**
     * execCommand 降级方案（兼容所有移动端）
     */
    execCopy(text) {
      // 创建临时 input（移动端用 input 比 textarea 更稳定）
      const input = document.createElement('input');
      input.value = text;

      // ⚠️ 关键：必须固定定位，避免页面滚动
      input.style.position = 'fixed';
      input.style.top = '-1000px';
      input.style.left = '-1000px';
      input.style.opacity = '0';
      input.style.pointerEvents = 'none'; // 禁止点击

      document.body.appendChild(input);

      // 选中文本（移动端需要兼容）
      input.focus();
      input.select();

      // iOS 特殊处理：使用 setSelectionRange
      if (navigator.userAgent.match(/ipad|iphone/i)) {
        input.setSelectionRange(0, text.length);
      }

      let success = false;
      try {
        success = document.execCommand('copy');
        this.$Notify({ type: "success", message: "复制成功", duration: 5000 });
      } catch (e) {
        this.$Notify({ type: "danger", message: "复制失败", duration: 5000 });
      }

      document.body.removeChild(input);
      return success;
    },
    updateDisabledFields() {
      const fields = ['mdsl11', 'mdsl12', 'mdsl13', 'mdsl14', 'mdsl15', 'mdsl16', 'mdsl17', 'mdsl18', 'mdsl19'];

      // 检查 mdsl19 是否有值
      const mdsl19Value = this.formDataInfo.mdsl19;
      const mdsl19HasValue = mdsl19Value && mdsl19Value.length > 0;

      // 找到第一个没有值的字段
      let firstEmptyIndex = -1;
      let allHaveValue = true;
      for (let i = 0; i < fields.length; i++) {
        const value = this.formDataInfo[fields[i]];
        const hasValue = value && value.length > 0;

        if (!hasValue && firstEmptyIndex === -1) {
          firstEmptyIndex = i;
        }
        if (!hasValue) {
          allHaveValue = false;
        }
      }

      // 更新 disabledFields
      const newDisabledFields = {};
      for (let i = 0; i < fields.length; i++) {
        const fieldKey = fields[i];
        let disabled;

        if (mdsl19HasValue || allHaveValue) {
          // mdsl19 有值，或者所有字段都有值 → 全部禁用
          disabled = true;
        } else if (firstEmptyIndex !== -1) {
          // 找到第一个没有值的字段 → 只有这个字段可以操作
          disabled = i !== firstEmptyIndex;
        } else {
          // 都没值 → 只有 mdsl11（索引0）可以操作
          disabled = i !== 0;
        }

        newDisabledFields[fieldKey] = disabled;
      }

      this.disabledFields = newDisabledFields;
    },
    handleClick(fieldKey) {
      if (!this.disabledFields[fieldKey]) {
        this.dateProjectShow = true;
        this.key1 = fieldKey;
      }
    },
    handleScroll(event) {
      const container = event.target;
      const { scrollTop, scrollHeight, clientHeight } = container;

      // 判断是否滚动到底部
      const isAtBottom = Math.abs(scrollHeight - scrollTop - clientHeight) <= this.scrollThreshold;

      if (isAtBottom && !this.isBottom) {
        this.isBottom = true;
        // console.log('滚动到底部了！');
        this.onScrollToBottom(); // 触发底部事件
      } else if (!isAtBottom && this.isBottom) {
        this.isBottom = false;
      }
    },

    onScrollToBottom() {
      // 滚动到底部时的处理逻辑
      // console.log('执行滚动到底部的操作');
      // 例如：加载更多数据、显示提示等
    },
    setupWatcher() {
      this.$watch('formDataInfo', (newVal) => {
        Object.keys(newVal).forEach(key => {
          if (this.lastForm[key] !== newVal[key]) {
          }
        })

        // 更新记录
        this.lastForm = { ...newVal }

        let params = {
          model: JSON.stringify([this.lastForm]),
        };

        AddOrUpdateComponenttraceData(params).then(res => {

        });
      }, { deep: true })
    },
    async getComponenttraceDataByIdFC() {
      let params = {
        id: this.$route.query.id
      }
      const { Data } = await GetComponenttraceDataById({ params })
      debugger
      if (!Data) {
        this.$Notify({ type: "danger", message: "数据丢失", duration: 3000 });
        setTimeout(() => {
          this.$router.go(-1)
        }, 3000);
      }

      this.lastForm = { ...Data }

      this.formDataInfo = Data


      // this.setupWatcher()
    },
    onConfirm(value, index) {
      this.formDataInfo.mdsl08 = value
      this.cutProjectShow = false
      this.key = 'mdsl08';
      this.changeInfo()
    },
    InsertgjxgRecordFC(id, olddata, newdata, zd) {
      let params = {
        id,
        olddata,
        newdata,
        zd
      }
      InsertgjxgRecord(params).then(res => {
      })
    },
    dateConfirm(value) {
      // 将日期对象格式化为字符串
      const date = new Date(value)
      // YYYY/MM/DD
      this.dateProjectShow = false;
      this.key = JSON.parse(JSON.stringify(this.key1));
      this.formDataInfo[this.key] = this.formatSlash(date);

      this.changeInfo()
    },
    // 格式化为斜杠分隔
    formatSlash(date) {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}/${month}/${day}`
    },
    changeInfo(v) {
      let params = {
        model: JSON.stringify([this.formDataInfo]),
      };
      AddOrUpdateComponenttraceData(params).then(res => {
        if (res.Code) {
          this.InsertgjxgRecordFC(this.formDataInfo.mdsl01, this.lastForm[this.key], this.formDataInfo[this.key], this.key)
          this.$Notify({ type: "success", message: "操作成功" });
          this.getComponenttraceDataByIdFC()
        }
      });
    }
  }
}
</script>

<style scoped>
.bottom-hint {
  position: sticky;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  margin: 10px auto;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 10px;
  font-size: 20px;
  z-index: 10;
  width: 40%;
  animation: fadeInUp 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>
